module.exports = __webpack_public_path__ + "images/yusuanbaobiao.svg";